import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export type BoardJournalEntry = {
  id: string; kind: "space" | "card"; space_index: number | null; space_title: string | null;
  deck: string | null; card_text: string | null; outcome: string | null; tokens_after: number | null; created_at: string;
};
type NewEntry = Omit<BoardJournalEntry, "id" | "created_at">;

/** Private, owner-only log of every space landed on and card drawn on the Recovery Board. */
export function useBoardJournal() {
  const [entries, setEntries] = useState<BoardJournalEntry[]>([]);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    supabase.from("recovery_board_journal").select("*").order("created_at", { ascending: false }).limit(50)
      .then(({ data, error }) => { if (error) setFailed(true); else setEntries((data ?? []) as BoardJournalEntry[]); });
  }, []);

  const record = useCallback(async (e: NewEntry) => {
    const { data, error } = await supabase.from("recovery_board_journal").insert(e).select().single();
    if (error) { setFailed(true); return; }
    setFailed(false);
    setEntries((p) => [data as BoardJournalEntry, ...p].slice(0, 50));
  }, []);

  return { entries, record, failed };
}
